<form [formGroup]="form()" class="flex flex-col gap-4">
    <!-- Referral name -->
    <sh-input-text
        data-testid="details-refer-out-dialog-input-referral-name"
        formControlName="name"
        [label]="'nam.parallel-referral-dialog.form.name' | translate"
        [error]="form().controls.name.touched && form().controls.name.invalid"
        [attr.error-message]="
            form().controls.name.hasError('required') && form().controls.name.touched
                ? ('nam.parallel-referral-dialog.form.name-required' | translate)
                : null
        "
        mandatory
    ></sh-input-text>

    <!-- Assignee: user or team -->
    <sh-assignee-picker
        data-testid="details-refer-out-dialog-input-assignee"
        formControlName="assignee"
        [label]="'common.request-tables.assignee' | translate"
        [teamIndicator]="'nam.parallel-referral-dialog.form.team-indicator' | translate"
        [placeholder]="'common.request-tables.assignee' | translate"
        [roles]="roles()"
        [businessService]="businessService()"
        [excludeIds]="excludeIds()"
        [error]="form().controls.assignee.touched && form().controls.assignee.invalid"
        [mandatory]="true"
        optionTestId="details-refer-out-dialog-option-assignee"
    ></sh-assignee-picker>
    @if (form().controls.assignee.touched && form().controls.assignee.hasError('required')) {
        <span class="text-xs text-shui-feedback-red -mt-3">
            {{ 'nam.parallel-referral-dialog.form.assignee-required' | translate }}
        </span>
    }

    <!-- Internal message toggle -->
    @if (canMarkCommentAsInternal()) {
        <sh-checkbox
            formControlName="markAsInternal"
            [label]="'common.request-detail.comments.internal-message' | translate"
        ></sh-checkbox>
    }

    <!-- Description / comment -->
    <sh-editor
        data-testid="details-refer-out-dialog-textarea-description"
        formControlName="description"
        [placeholder]="
            (isReferredOutAfterSubmission()
                ? 'request.requestDetail.parallel-referral-dialog.form.task-description-optional'
                : 'nam.parallel-referral-dialog.form.task-description'
            ) | translate
        "
        class="w-full"
    ></sh-editor>
    @if (!isReferredOutAfterSubmission()) {
        @if (form().controls.description.touched && form().controls.description.hasError('required')) {
            <span class="text-xs text-shui-feedback-red -mt-3">
                {{ 'nam.parallel-referral-dialog.form.task-description-required' | translate }}
            </span>
        }
    }

    <!-- File upload -->
    <sh-file-input formControlName="attachments" [multiple]="true" class="w-full"></sh-file-input>
</form>
